/**
 * Application Constants
 * 
 * Centralized configuration for app-wide constants.
 * Update values here to apply changes across all pages.
 */

/**
 * Minimum Collateral Required (in USD)
 * 
 * Users must have at least this amount deposited to:
 * - Issue Letters of Credit
 * - Apply for loans
 * 
 * Production: Should be $500
 * Testing: Temporarily set to $1 for easier testing
 */
export const MINIMUM_COLLATERAL_USD = 1

/**
 * Loan to Value (LTV) Ratios
 */
export const RECOMMENDED_LTV = 50 // 50% LTV recommended for safety
export const MAX_LTV = 75 // 75% maximum LTV allowed
export const DANGER_LTV = 65 // Above 65% shows as risky

/**
 * UI Display Constants
 */
export const DEFAULT_CURRENCY = 'USD'
export const DEFAULT_CHAIN_ID = 1 // Ethereum Mainnet

